// True only on the actual SG homepage (/ when the build has SG enabled) or
// its staging preview (/sg-preview) — NOT true for the whole SG site. Used by
// every component that should show SG-specific styling exclusively on that
// one page (Brands, HomepageForm, FooterCopyright), so they don't leak SG
// treatment onto every other page just because NEXT_PUBLIC_IS_SG is set.
export function isSgLandingPage(pathname: string | null | undefined) {
    return (
        (pathname === "/" && process.env.NEXT_PUBLIC_IS_SG === "true") ||
        pathname === "/sg-preview"
    );
}
